import React, { useRef } from "react";
import Banner from "../Banner";
import BannerTwo from "../BannerTwo";
import Carousel from "react-bootstrap/Carousel";
import { GoArrowLeft, GoArrowRight } from "react-icons/go";
import { BannerArrowOne, BannerArrowTwo } from "../../assets/svg";
import BannerThree from "../BannerThree";
import BannerFour from "../BannerFour";
import BannerFive from "../BannerFive";
const BannerSlider = () => {
  const carouselRef = useRef(null);

  const handlePrev = () => {
    if (carouselRef.current) {
      carouselRef.current.prev();
    }
  };

  const handleNext = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  return (
    <div className="volto-grdient-banner-slider">
      <Carousel controls={false} indicators={false} ref={carouselRef}  pause={false}   interval={4500}>
         <Carousel.Item>
          <div>
            <BannerThree />
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div>
            <BannerFive />
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div>
            <Banner />
          </div>
        </Carousel.Item>
        {/* <Carousel.Item>
          <div>
            <BannerTwo />
          </div>
        </Carousel.Item> */}

       
        {/* <Carousel.Item>
          <div>
            <BannerFour />
          </div>
        </Carousel.Item> */}
        
         {/* <Carousel.Item>
          <div>
            <BannerThree />
          </div>
        </Carousel.Item>
         */}
      </Carousel>

      <div className="banner-btn-row">
        <span className="custom-prev" onClick={handlePrev}>
        <BannerArrowOne />
        </span>
        <span className="custom-next" onClick={handleNext}>
        <BannerArrowTwo />
        </span>
      </div>
    </div>
  );
};

export default BannerSlider;
